import RecentPosts from "@/components/blog/RecentPosts";
import SearchBar from "@/components/blog/SearchBar";
import SocialMediaSection from "@/components/blog/SocialMediaSection";
import VillaRentalAreas from "@/components/blog/VillaRentalAreas";
import React from "react";
import BreadCrumb from "../Listing/BreadCrumb";
import styles from "@/styles/blog.module.css";

const BlogDetail = ({ data, dataHeader }) => {
  return (
    <div className="py-6">
      <div className="container">
        <div className="grid grid-cols-12 md:gap-x-8">
          <div className="col-span-12 mb-5 lg:col-span-8 md:mb-0">
            <div className="mb-5 lg:mb-10 md:mb-7">
              <BreadCrumb data={data} />
            </div>
            <div
              dangerouslySetInnerHTML={{ __html: data?.icerik }}
              className={styles.blogContent}
            />
          </div>
          <div className="col-span-12 lg:col-span-3">
            <div className="mb-4">
              <SearchBar />
            </div>
            <SocialMediaSection dataHeader={dataHeader} />
            <RecentPosts posts={data?.BlogData?.LastShared} />
            <VillaRentalAreas />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
